import {
  Box,
  Card,
  CardBody,
  Text,
  VStack,
  HStack,
  Progress,
  Badge,
  SimpleGrid,
  Avatar,
  Flex,
  Spacer,
} from '@chakra-ui/react';
import { useEstadisticasDictamenes } from '../../hooks/useEstadisticasDictamenes';
import type { Dictamen } from './types';

interface EstadisticasOperadoresProps {
  dictamenes: Dictamen[];
}

export default function EstadisticasOperadores({ dictamenes }: EstadisticasOperadoresProps) {
  const { porOperador, total } = useEstadisticasDictamenes(dictamenes);

  const operadoresOrdenados = Object.entries(porOperador)
    .sort(([,a], [,b]) => b - a)
    .slice(0, 5); // Top 5 operadores

  return (
    <Card>
      <CardBody>
        <VStack spacing={4} align="stretch">
          <Flex align="center">
            <Text fontSize="lg" fontWeight="bold" color="#5b182b">
              Rendimiento por Operador
            </Text>
            <Spacer />
            <Badge bg="#bb8c52" color="white">
              Top 5
            </Badge>
          </Flex>
          
          <SimpleGrid columns={1} spacing={3}>
            {operadoresOrdenados.map(([operador, cantidad], index) => {
              const porcentaje = (cantidad / total) * 100;
              const iniciales = operador.split(' ').map(n => n[0]).join('').toUpperCase();
              
              return (
                <Box key={operador} p={3} bg="gray.50" borderRadius="md">
                  <HStack spacing={3}>
                    <Avatar 
                      size="sm" 
                      name={operador}
                      bg={index === 0 ? '#bb8c52' : '#5b182b'}
                      color="white"
                    />
                    <VStack align="start" spacing={1} flex={1}>
                      <HStack w="100%" justify="space-between">
                        <Text fontWeight="semibold" fontSize="sm">
                          {operador}
                        </Text>
                        <Text fontSize="sm" color="gray.600">
                          {cantidad} ({porcentaje.toFixed(1)}%)
                        </Text>
                      </HStack>
                      <Progress 
                        value={porcentaje} 
                        size="sm" 
                        w="100%"
                        colorScheme="none"
                        bg="gray.200"
                        sx={{
                          '& > div': {
                            bg: index === 0 ? '#bb8c52' : '#5b182b'
                          }
                        }}
                      />
                    </VStack>
                  </HStack>
                </Box>
              );
            })}
          </SimpleGrid>
        </VStack>
      </CardBody>
    </Card>
  );
}